import { useGetFrontRichiesteV2IdComunicazioni } from '@framework/api-client/api/inquiries-compile/comunicazioni-v2/comunicazioni-v2.ts';
import { UnreadCountBadge } from '@framework/common-web/ui/communication/UnreadCountBadge.tsx';

export interface IUnreadCommunicationsBadgeProps {
  submissionId: string | null | undefined;
}

/**
 * Contatore delle comunicazioni non lette della richiesta, mostrato
 * sulla scheda "Comunicazioni". Riusa la ricerca filtrata su flLetta
 * (come per le notifiche): nessun endpoint dedicato.
 */
export function UnreadCommunicationsBadge(
  props: IUnreadCommunicationsBadgeProps,
) {
  const { submissionId } = props;

  const { data } = useGetFrontRichiesteV2IdComunicazioni(
    submissionId ?? '<unknown>',
    { flLetta: false, limite: 1 },
    {
      query: {
        enabled: !!submissionId,
        keepPreviousData: true,
      },
    },
  );

  return <UnreadCountBadge count={data?.meta?.totale ?? 0} />;
}
